import React, { useState } from 'react';
import * as qs from 'query-string';
import { useLocation } from 'react-router-dom';

import RetencionCreate from './create/RetencionCreate';
import PageHeader from '../../support/page-header/PageHeader';
import UsePreviousIssuedRetencionInput from './support/UsePreviousIssuedRetencionInput';

const RetencionesCreate = (props) => {
  const [data, setData] = useState(undefined);
  const location = useLocation();

  const handleOnStartPointChange = (value) => {
    setData(value);
  };

  const query = qs.parse(location.search);

  const info = {
    pathname: `/app/retenciones/${query?.u}/info`,
    state: {
      data: { ...data },
    },
  };

  return (
    <div className="retenciones-create">
      <PageHeader
        to={!!query.u ? info : '/app/retenciones'}
        text="Retenciones"
      />

      {query.u !== undefined && (
        <UsePreviousIssuedRetencionInput
          simple={query.u !== undefined}
          related={query.r}
          uuid={query.u}
          onChange={handleOnStartPointChange}
        />
      )}

      <RetencionCreate data={data} />
    </div>
  );
};

export default RetencionesCreate;
